import { ShieldAlert } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";

/**
 * Slim, always-visible policy bar fixed at the very top of the page.
 * Announces the 48-hour cover policy in the currently selected language.
 * Height is tuned to match the CSS var --policy-bar-h so the Header and
 * Hero can offset themselves cleanly (no overlap, no bugs).
 */
export default function PolicyBar() {
  const { t } = useT();
  return (
    <div
      data-testid="policy-bar"
      role="note"
      aria-label="Service policy"
      className="fixed top-0 left-0 right-0 z-[60] bg-[#0A0A0A] text-white border-b border-white/10"
      style={{ height: "var(--policy-bar-h)" }}
    >
      <a
        href="#faq"
        className="max-w-7xl mx-auto h-full px-4 sm:px-8 lg:px-12 flex items-center gap-2 sm:gap-3 hover:bg-white/[0.03] transition-colors"
      >
        <span className="hidden sm:inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#1E63FF] shrink-0">
          <ShieldAlert className="w-3.5 h-3.5" strokeWidth={2.2} />
        </span>
        <span className="sm:hidden inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#1E63FF] shrink-0">
          <ShieldAlert className="w-3 h-3" strokeWidth={2.2} />
        </span>
        <p
          data-testid="policy-bar-text"
          className="text-[11px] sm:text-[13px] leading-snug font-medium text-white/95 truncate sm:whitespace-normal"
        >
          <span className="font-bold text-[#7FB0FF] mr-1.5">{t.policy.label}:</span>
          <span className="hidden sm:inline">{t.policy.text}</span>
          <span className="sm:hidden">{t.policy.short}</span>
        </p>
      </a>
    </div>
  );
}
